// extracted by mini-css-extract-plugin
module.exports = {"main":"QsrStatus_main__SftDi","label":"QsrStatus_label__md6ZR","status":"QsrStatus_status__8UoA4"};